import { useMemo } from 'react';

import { BadgeBackgroundColor, BadgeBorderColor, BANNER_TYPE } from '@/types';
import { ItemModel, ProductModel } from '@/models';

import { getAttributeId, isPrimeurCode } from '@/utils/productUtils';
import { getAvailabilityIndicator } from '@/utils/availabilityIndicatorUtils';

import Banner from '@/components/common/Banner';
import AvailabilityBadge from '@/components/common/badge/AvailabilityBadge';

import styles from './AvailabilityIndicator.module.scss';
import { STORE_ID } from '@/constants/stores';

type AvailabilityIndicatorProps = {
  t: (k: string) => string;
  product: ProductModel;
  currentItem: ItemModel;
  storeId: string;
  locale: string;
  isProductPage?: boolean;
  customClassName?: string;
}

const AvailabilityIndicator = ({
  t,
  product,
  currentItem,
  storeId,
  locale = 'fr-FR',
  isProductPage = false,
  customClassName = ''
}: AvailabilityIndicatorProps) => {
  const availabilities = useMemo(() => {
    return getAvailabilityIndicator(t, storeId, product, currentItem, locale);
  }, [product, currentItem]);
  const firstAvailability = availabilities?.[0];
  const message = firstAvailability?.message ?? '';
  const color = firstAvailability?.color ?? BadgeBackgroundColor.SUCCESS;

  const className = [
    styles.container,
    customClassName
  ].join(' ');

  const showBanner = isProductPage && storeId === STORE_ID.USA &&
  (getAttributeId(currentItem, 'prearrival_o_n') === '1' || isPrimeurCode(getAttributeId(product, 'in_stock')));

  return (
    <div className={className} data-test-id="availability-indicator">
      <AvailabilityBadge background={color} border={BadgeBorderColor.WHITE} label={message} />
      {showBanner && (
        <div className={styles.banner}>
          <Banner
            type={BANNER_TYPE.INFORMATION}
            content={t('product.availability.taxesInfos')}
          />
        </div>
      )}
    </div>
  );
};

export default AvailabilityIndicator;
